import Model from "./Model";
import { Position } from "./Position";

export const milan = { lat: 45.47741454797728, lng: 9.199590998404119 };

export enum COMPANY_PLACE_SOURCE {
  GOOGLE_PLACES = "google_places",
  MANUAL = "manual",
}

export class CompanyPlaceFilter {
  companyId?: string;

  toParams() {
    const params = [];
    if (this.companyId) {
      params.push(`filter[company_id]=${encodeURIComponent(this.companyId)}`);
    }

    const base = "?include=*";
    if (params.length > 0) {
      return `${base}&${params.join("&")}`;
    }
    return base;
  }
}

export default class CompanyPlace extends Model {
  static type = "clientPlaces";

  name!: string;
  companyId!: string;
  fullAddress!: string;
  position!: Position;
  highlighted = false;
  source!: string;
  sourceId!: string;
  status!: string;

  static dummy() {
    let place = new CompanyPlace();
    place.name = "Milano";
    place.position = new Position(45.47741454797728, 9.199590998404119);
    return place;
  }

  static fromGooglePlace(googlePlace: any) {
    let place = new CompanyPlace();
    place.id = googlePlace.place_id;
    place.sourceId = googlePlace.place_id;
    place.source = "google_places";
    place.name = googlePlace.name;
    const position = googlePlace.geometry.location;
    place.position = new Position(position.lng(), position.lat());
    place.fullAddress = googlePlace.formatted_address;
    return place;
  }

  get toJson() {
    return {
      name: this.name,
      source: "google_places",
      position: this.position,
      sourceId: this.sourceId,
      fullAddress: this.fullAddress,
      status: this.status,
    };
  }

  get incomplete() {
    return this.source === "google_places" && this.status === "not_found";
  }
}
